import { create } from 'zustand'
import dayjs from 'dayjs'
import 'dayjs/locale/vi'
import i18n from '@/lib/i18n'

type Language = 'en' | 'vi'

interface LanguageStore {
  language: Language
  debugMode: boolean
  setLanguage: (lang: Language) => void
  toggleDebugMode: () => void
  initializeLanguage: () => void
}

export const useLanguageStore = create<LanguageStore>((set) => ({
  language: (i18n.language as Language) || 'en',
  debugMode: false,

  setLanguage: (lang: Language) => {
    console.log('🔄 Changing language to:', lang);
    i18n.changeLanguage(lang);
    dayjs.locale(lang);
    console.log('✅ Language changed, current i18n language:', i18n.language);
    localStorage.setItem('app-language', lang);
    set({ language: lang });
  },

  toggleDebugMode: () => {
    set((state) => ({
      debugMode: !state.debugMode,
    }))
  },

  initializeLanguage: () => {
    // Get the detected language from i18n (which uses LanguageDetector)
    const detectedLang = (i18n.language as Language) || 'en'
    const savedLanguage = (localStorage.getItem('app-language') as Language) || detectedLang
    i18n.changeLanguage(savedLanguage)
    dayjs.locale(savedLanguage)
    set({ language: savedLanguage })
  },
}))
